// extracted by mini-css-extract-plugin
module.exports = {"Notification":"Notification_Notification__3XtaW","isHidden":"Notification_isHidden__cCG66"};